export const parseAspNetDate = (aspNetDate: string): Date => {
  const match = aspNetDate.match(/\d+/);
  if (!match) throw new Error('Invalid date format');
  const timestamp = parseInt(match[0], 10);
  return new Date(timestamp);
};
